import { ReactElement, Suspense } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import PrivateRoute from './PrivateRoute';
import Layout from "./Layout/Layout";

interface Props {
    children: ReactElement;
}

const RouteFallback = () => (
    <div className="flex items-center justify-center h-64">
        <ClipLoader color="#4A90E2" size={50} />
    </div>
);

export const PortalRoute = ({ children }: Props) => {
    return (
        <PrivateRoute>
            <Layout>
                <Suspense fallback={<RouteFallback />}>{children}</Suspense>
            </Layout>
        </PrivateRoute>
    );
};

export default PortalRoute;
